import { ColumnDef } from '@tanstack/react-table';
import { ArrowRight, Trash } from '@phosphor-icons/react';
import { DataTableColumnHeader } from '@/components/core';
import { PROFILE_SOURCES } from '../../../shared/candidate-form-schema';
import { Button } from '@/components/ui-kit/button';
import { PotentialProfile } from '../../types/profile.types';

interface CreateProfileTableColumnsProps {
  t: (key: string) => string;
  onTransfer: (profile: PotentialProfile) => void;
  onDelete: (profile: PotentialProfile) => void;
}

export const createProfileTableColumns = ({
  t,
  onTransfer,
  onDelete,
}: CreateProfileTableColumnsProps): ColumnDef<PotentialProfile>[] => [
  {
    // Shows the full name; sorts and filters by first name.
    id: 'FirstName',
    meta: { filter: { type: 'text' } },
    header: ({ column }) => <DataTableColumnHeader column={column} title={t('NAME')} />,
    accessorFn: (row) => `${row.FirstName} ${row.LastName}`,
  },
  {
    id: 'Email',
    meta: { filter: { type: 'text' } },
    header: ({ column }) => <DataTableColumnHeader column={column} title={t('EMAIL')} />,
    accessorFn: (row) => row.Email,
  },
  {
    id: 'Designation',
    meta: { filter: { type: 'text' } },
    header: ({ column }) => <DataTableColumnHeader column={column} title={t('DESIGNATION')} />,
    accessorFn: (row) => row.Designation,
  },
  {
    id: 'Source',
    meta: {
      filter: {
        type: 'options',
        options: PROFILE_SOURCES.map((source) => ({ value: source, label: source })),
      },
    },
    header: ({ column }) => <DataTableColumnHeader column={column} title={t('SOURCE')} />,
    accessorFn: (row) => row.Source,
  },
  {
    id: 'YearsOfExperience',
    meta: { filter: { type: 'number' } },
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title={t('YEARS_OF_EXPERIENCE')} />
    ),
    accessorFn: (row) => row.YearsOfExperience,
  },
  {
    id: 'actions',
    // Card: top right, as the old portal's card header.
    meta: { mobile: 'badge' as const },
    header: () => <span className="text-xs font-medium">{t('ACTION')}</span>,
    enableSorting: false,
    enableHiding: false,
    cell: ({ row }) => (
      <div className="flex items-center gap-1">
        <Button variant="outline" size="sm" onClick={() => onTransfer(row.original)}>
          <ArrowRight className="size-4" />
          {t('TRANSFER')}
        </Button>
        <Button
          variant="ghost"
          size="icon"
          onClick={() => onDelete(row.original)}
          aria-label={t('DELETE')}
        >
          <Trash className="size-4" />
        </Button>
      </div>
    ),
  },
];
